import Attribute from "../../../model/formconfiguration/Attribute";
import { formatBooleanValue } from "../../..";

const AttributeListMapper = (json: any[] = []) => {
  return json.map((item: any) => {
    let attribute = Attribute(item);
    attribute.valid = formatBooleanValue(item.valid);
    return attribute;
  });
};
export default AttributeListMapper;
